// Merges the 4 monitoring sub-pages into tabs on one route, per the approved
// restructure plan. All four already resolve to the same "monitoring" billing
// feature (see App.jsx's FEATURE_ACCESS_ALIASES), so this needs no gating
// change — the single FeatureGate wrapping /monitoring covers all four tabs.
// Each existing page component is mounted unmodified as a tab panel.
import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs } from "../common/ui.jsx";
import UrlTracker from "../UrlTracker/UrlTracker.jsx";
import FileUpload from "../fileUpload/fileUpload.jsx";
import FileMonitor from "../FileMonitor/filemonitor.jsx";
import UsbControl from "../usb/usb.jsx";

const TABS = [
  { id: "url", label: "URL", Component: UrlTracker },
  { id: "uploads", label: "File Uploads", Component: FileUpload },
  { id: "changes", label: "File Changes", Component: FileMonitor },
  { id: "usb", label: "USB", Component: UsbControl },
];

export default function MonitoringHub() {
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedTab = searchParams.get("tab");
  const activeTab = TABS.find((t) => t.id === requestedTab) ? requestedTab : TABS[0].id;
  const ActivePanel = useMemo(() => TABS.find((t) => t.id === activeTab).Component, [activeTab]);

  return (
    <div className="monitor-hub">
      <Tabs
        tabs={TABS}
        activeId={activeTab}
        onChange={(id) => setSearchParams(id === TABS[0].id ? {} : { tab: id })}
      />
      <ActivePanel />
    </div>
  );
}
